import { publicOrigin, secureOrigin } from '@maxpreps/network/src/origins';
import { formatGenderSportId } from '@maxpreps/shared/functions/utils/teamUtils';
import { getReturnUrl } from '../functions/primitiveHelpers/urlHelpers';

// General

export const MAXPREPS_HOME = publicOrigin;

const baseMemberPath = '/utility/member';
export const PROFILE_URL = `${secureOrigin}${baseMemberPath}/profile.aspx`;

const appendQueryParams = (
  url: string,
  queryParams: string | undefined
): string => {
  if (!queryParams) return url;

  return `${url}${url.indexOf('?') > -1 ? '&' : '?'}${queryParams}`;
};

const ftagKey = 'ftag';
const appendFTag = (url: string): string => {
  const params = new URLSearchParams(window.location.search);

  return appendQueryParams(
    url,
    params.get(ftagKey) ? `${ftagKey}=${params.get(ftagKey)}` : undefined
  );
};

// Account
const appendReturnUrl = (url: string, ignoreReturnUrl: boolean) =>
  appendQueryParams(
    url,
    ignoreReturnUrl ? undefined : `returnurl=${getReturnUrl()}`
  );

export const getAuthenticateSessionUrl = (
  source: string,
  ignoreReturnUrl: boolean = false,
  queryParams: string | undefined = undefined
) =>
  appendQueryParams(
    appendReturnUrl(
      `${secureOrigin}${baseMemberPath}/request_password.aspx?source=${source}`,
      ignoreReturnUrl
    ),
    queryParams
  );

export const getSignInUrl = (
  source: string,
  ignoreReturnUrl: boolean = false,
  queryParams: string | undefined = undefined
) =>
  appendQueryParams(
    appendReturnUrl(
      `${secureOrigin}${baseMemberPath}/login.aspx?source=${source}`,
      ignoreReturnUrl
    ),
    queryParams
  );

export const getSignOutUrl = (ignoreReturnUrl: boolean = false) =>
  appendReturnUrl(
    `${secureOrigin}${baseMemberPath}/logout.aspx`,
    ignoreReturnUrl
  );

export const getCreateAccountUrl = (
  source: string,
  ignoreReturnUrl: boolean = false,
  queryParams: string | undefined = undefined
) =>
  appendQueryParams(
    appendReturnUrl(
      `${secureOrigin}${baseMemberPath}/register.aspx?source=${source}`,
      ignoreReturnUrl
    ),
    queryParams
  );

export const clientGoToRoute = (url: string): void => {
  if (typeof window === 'undefined') return;

  window.location.href = appendFTag(url);
};

// Articles

export const getArticlesUrl = (
  gender: undefined | string = undefined,
  sport: undefined | string = undefined,
  stateCode: undefined | string = undefined,
  sectionId: undefined | string = undefined
): string => {
  const url = new URL(`${publicOrigin}/news/articles_list.aspx`);

  if (gender && sport) {
    url.searchParams.append('gendersport', formatGenderSportId(gender, sport));
  }
  if (stateCode) {
    url.searchParams.append('state', stateCode);
  }
  if (sectionId) {
    url.searchParams.append('sectionid', sectionId);
  }

  return url.toString();
};

// Team

export const getPrintScheduleUrl = (schoolId: string, ssid: string): string =>
  `${publicOrigin}/print/schedule.aspx?schoolid=${schoolId}&ssid=${ssid}&print=1`;

export const getLineupSheetUrl = (schoolId: string, ssid: string): string =>
  `${publicOrigin}/print/lineupsheet.aspx?print=1&schoolid=${schoolId}&ssid=${ssid}`;

export const getPBPSignUpUrl = (schoolId: string, ssid: string): string =>
  `${publicOrigin}/scores/play_by_play_signup.aspx?schoolid=${schoolId}&ssid=${ssid}`;

export const getUploadVideoUrl = (
  schoolId: string,
  genderSport: string
): string =>
  `${publicOrigin}/utility/uploads/video/default.aspx?gendersport=${genderSport}&schoolid=${schoolId}`;

export const getRosterCorrectionUrl = (
  schoolId: string,
  schoolState: string,
  ssid: string
): string =>
  `${publicOrigin}/utility/support/correction.aspx?t=1&schoolid=${schoolId}&ssid=${ssid}&state=${schoolState}`;
